import type { DayFacts } from './day-facts';
import { isHardFlag } from './flags';

export type AlertLevel = 'ok' | 'attention' | 'urgent';

/**
 * How urgently the family hears about today's call.
 *   urgent    — notify the family right now (call + message)
 *   attention — highlight at the top of today's summary
 *   ok        — regular summary
 *
 * `history` holds previous days, newest first, up to 7. A missed call ("did not answer")
 * is handled by the telephony layer, not here.
 */
export function alertLevel(today: DayFacts, _history: readonly DayFacts[] = []): AlertLevel {
  if (today.redFlags.some(isHardFlag)) return 'urgent';
  if (today.attentionFlags.some(isHardFlag)) return 'attention';

  // TODO(owner): gray-zone rules, 5–10 lines; rename `_history` to `history` when used.
  // Decide: repeated complaint within 7 days (the landing promises "knee, second time this week"
  // → attention), missed medicines, several low-mood days in a row, a severe complaint without
  // red flags, and scam_contact. Pending checks: test/alert-rules.test.ts (todo) and the
  // `knee-repeat` eval case.

  return 'ok';
}
